import MacAddressRedirect from './MacAddressRedirect';

export default MacAddressRedirect;
